/**
 * DataLayer - smsVerification event
 * @description Если пользователь дошел до смс-верификации, генерируется событие 'smsVerification'.
 *
 * @example DLSMSVerificationEvent({result: 'timeout', eventLabel?: globalThis?.location?.href})
 *
 * @default event: "smsVerification"
 * @param result: результат получения смс
 * @param eventLabel: Страница на которой произошло событие
 */

import { pushToDL } from "../utils/helper"
import type { TDLPageURL } from "./type"

export type TDLSMSVerification =
  | "success" // Успешная смс-верификация
  | "fail" // Неуспешная смс-верификация
  | "exceeded" // Истекло время жизни кода
  | "sended" // Отправлена форма для получения кода
  | "changeNumber" // Изменение номера
  | "resend" // Повторная отправка смс-кода
  | "timeout" // Вышло время
  | "loaded" // Компонент загрузился

type TDLSMSEvent = {
  result: TDLSMSVerification
  eventLabel?: TDLPageURL
}

export const DLSMSVerificationEvent = ({
  result,
  eventLabel = globalThis?.location?.href,
}: TDLSMSEvent) => {
  pushToDL({ event: "smsVerification", result, eventLabel })
}
